'use client';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import { useState } from 'react';

import cn from './style.module.sass';

type ReadMorePropsType = {
    list: { id: string; text: string }[];
};
const ReadMore = ({ list }: ReadMorePropsType) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <FullWrapper className={cn['text']} isMargin={false}>
            <ScrollAnimation>
                <div className={cn['text__left']}>
                    {list.map(({ id, text }) => {
                        // eslint-disable-next-line xss/no-mixed-html
                        return (
                            <div
                                key={id}
                                dangerouslySetInnerHTML={{
                                    /* eslint-disable-next-line xss/no-mixed-html,no-magic-numbers */
                                    __html: isExpanded ? text : text.slice(0, 401),
                                }}
                                className={cn['text__Content']}
                            />
                        );
                    })}

                    <button className={cn['text__button']} onClick={handleToggle}>
                        {isExpanded ? 'Скрыть' : 'Читать далее'}
                    </button>
                </div>
            </ScrollAnimation>
        </FullWrapper>
    );
};

export default ReadMore;
